import React from "react";
import { ScoreIcon } from "../../icons";

const LandingScore = () => {
  return (
    <section className="events-page-landing-section events-page-landing-section-fill events-page-landing-section-space events-page-landing-score">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-landing-score-content">
          <div className="events-page-landing-score-content-item">
            <div className="events-page-landing-score-content-item-icon">
              <ScoreIcon type="graph" />
            </div>
            <div className="events-page-landing-score-content-item-title">
              80%
            </div>
            <div className="events-page-landing-score-content-item-text">
              of companies see better share price stability after 6 months
            </div>
          </div>
          <div className="events-page-landing-score-content-item">
            <div className="events-page-landing-score-content-item-icon">
              <ScoreIcon type="video" />
            </div>
            <div className="events-page-landing-score-content-item-title">
              215%
            </div>
            <div className="events-page-landing-score-content-item-text">
              average growth in active investor engagement within 6 months
            </div>
          </div>
          <div className="events-page-landing-score-content-item">
            <div className="events-page-landing-score-content-item-icon">
              <ScoreIcon type="user" />
            </div>
            <div className="events-page-landing-score-content-item-title">
              400+
            </div>
            <div className="events-page-landing-score-content-item-text">
              public companies trust 6ix for investor community building
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingScore;
